import {Directive, ElementRef, EventEmitter, HostListener, Input, Output, ChangeDetectorRef} from '@angular/core';
import {Subject, throttleTime} from 'rxjs';

@Directive({
    selector: '[dragHelper]',
    standalone: false
})
export class DragHelperDirective {
  private isTouch = false;
  private prepare = false;
  private dragging = false;
  private touchZoom = false;
  private nowX;
  private nowY;
  private oldX;
  private oldY;
  private oldDistance;
  private readyToPrepare = true;
  public moveSubject: Subject<any> = new Subject<any>();
  @Input() public withTouch = true;
  @Output() public startDragging = new EventEmitter<object>();
  @Output() public stopDragging = new EventEmitter<object>();
  @Output() public processDragging = new EventEmitter<object>();
  @Output() public DraggingClick = new EventEmitter<any>();
  @Output() public DraggingTouchZoom = new EventEmitter<any>();

  constructor(private _el: ElementRef, private cd: ChangeDetectorRef) {
    this.isTouch = ('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0);
    this.moveSubject.pipe(throttleTime(10)).subscribe((e) => this.moving(e.clientX, e.clientY));
  }

  @HostListener('mousedown', ['$event'])
  mousedown(event) {
    this.oldX = event.clientX;
    this.oldY = event.clientY;
    this.nowX = null;
    this.nowY = null;
    if (this.readyToPrepare) {
      this.prepare = true;
    }
  }

  @HostListener('mouseup', ['$event'])
  mouseup(event) {
    if (this.dragging) {
      this.stopDrag();
    } else {
      this.prepare = false;
      this.DraggingClick.emit(event);
    }
  }

  @HostListener('mouseleave', ['$event'])
  mouseleave(event) {
    if (this.dragging) {
      this.stopDrag();
    }
  }

  @HostListener('mousemove', ['$event'])
  mousemove(event) {
    this.moveSubject.next({clientX: event.clientX, clientY: event.clientY});
  }

  distance(event) {
    return Math.hypot(event.touches[0].clientX - event.touches[1].clientX,
      event.touches[0].clientY - event.touches[1].clientY);
  }

  @HostListener('touchstart', ['$event'])
  touchstart(event) {
    if (!this.withTouch) {
      return;
    }
    if (event.touches.length === 1) {
      this.oldX = event.touches[0].clientX;
      this.oldY = event.touches[0].clientY;
      this.nowX = null;
      this.nowY = null;
      this.prepare = true;
      this.touchZoom = false;
    } else if (event.touches.length > 1) {
      event.preventDefault(); // Prevent page scroll
      this.touchZoom = true;
      this.oldDistance = this.distance(event);
      if (this.dragging) {
        this.stopDrag();
      }
      // this.oldX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
      // this.oldY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
      // this.nowX = null;
      // this.nowY = null;
      // this.prepare = true;
    }
  }

  @HostListener('touchend', ['$event'])
  touchend(event) {
    if (!this.withTouch) {
      return;
    }
    if (this.dragging) {
      this.stopDrag();
    } else {
      this.prepare = false;
      // if (!this.touchZoom) {
      //   this.DraggingClick.emit(event);
      // }
    }
  }

  @HostListener('touchcancel', ['$event'])
  touchcancel(event) {
    if (!this.withTouch) {
      return;
    }
    if (this.dragging) {
      this.stopDrag();
    } else {
      this.prepare = false;
    }
  }

  @HostListener('touchmove', ['$event'])
  touchmove(event) {
    if (!this.withTouch) {
      return;
    }
    if (event.touches.length === 1) {
      this.moving(event.touches[0].clientX, event.touches[0].clientY);
    } else if (event.touches.length === 2) {
      event.preventDefault(); // Prevent page scroll

      // Safari provides event.scale as two fingers move on the screen
      // For other browsers just calculate the scale manually
      let scale;
      const deltaDistance = this.distance(event);
      scale = deltaDistance / this.oldDistance;
      this.oldDistance = deltaDistance;
      this.DraggingTouchZoom.emit({
        x: (event.touches[0].clientX + event.touches[1].clientX) / 2,
        y: (event.touches[0].clientY + event.touches[1].clientY) / 2,
        scale: scale
      });
    }
  }

  stopDrag() {
    if (this.dragging) {
      this.dragging = false;
      this.prepare = false;

      this.readyToPrepare = false;
      setTimeout(_ => {
        this.readyToPrepare = true;
      }, 100);

      this.send(true);
    }
  }

  send(isEnd = false) {
    // a lot of calls of this func, maybe use Subject auditTime or something else for optimization
    this.processDragging.emit({
      x: this.nowX - this.oldX,
      y: this.nowY - this.oldY
    });
    if (isEnd) {
      this.stopDragging.emit({
        x: this.nowX - this.oldX,
        y: this.nowY - this.oldY
      });
    }
    this.oldX = this.nowX;
    this.oldY = this.nowY;
  }

  moving(x, y) {
    if (this.prepare) {
      this.dragging = true;
      this.startDragging.emit();
      this.prepare = false;
    }
    if (this.dragging) {
      this.nowX = x;
      this.nowY = y;
      this.send();
    }
  }

}
